var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBengfang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4120_18823)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4120_18823)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4120_18823",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1L0 8H3V15H13V8H16L8 1Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1L0 8H3V15H13V8H16L8 1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8L-0.658505 7.24742L-2.66145 9H0V8ZM8 1L8.6585 0.247423L8 -0.328768L7.3415 0.247423L8 1ZM3 8H4V7H3V8ZM3 15H2V16H3V15ZM13 15V16H14V15H13ZM13 8V7H12V8H13ZM16 8V9H18.6614L16.6585 7.24742L16 8ZM0.658505 8.75258L8.6585 1.75258L7.3415 0.247423L-0.658505 7.24742L0.658505 8.75258ZM3 7H0V9H3V7ZM4 15V8H2V15H4ZM13 14H3V16H13V14ZM12 8V15H14V8H12ZM16 7H13V9H16V7ZM7.3415 1.75258L15.3415 8.75258L16.6585 7.24742L8.6585 0.247423L7.3415 1.75258Z",
    fill: "black",
    mask: "url(#path-1-inside-1_4120_18823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10C6 12 7 12.5 8 12.5C9 12.5 10 12 10 10C10 8.4 8.5 6.5 8 6C7.5 6.5 6 8.4 6 10Z",
    fill: "#26A4FF",
    stroke: "black",
    strokeWidth: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4120_18823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4120_18823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBengfang);
export default __webpack_public_path__ + "static/media/bengfang.9ff5b3966ffcae3fe3dd156efeda4cd0.svg";
export { ForwardRef as ReactComponent };